"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERegisterOrAuthByTokenStatus = void 0;
let ERegisterOrAuthByTokenStatus = exports.ERegisterOrAuthByTokenStatus = /*#__PURE__*/function (ERegisterOrAuthByTokenStatus) {
  ERegisterOrAuthByTokenStatus["Initial"] = "initial";
  ERegisterOrAuthByTokenStatus["Loading"] = "loading";
  ERegisterOrAuthByTokenStatus["Succeed"] = "succeed";
  ERegisterOrAuthByTokenStatus["Failed"] = "failed";
  return ERegisterOrAuthByTokenStatus;
}({});